import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import pandy from '../assets/images/goldenshine.png'
import candy from '../assets/images/goldenshine2.jpg'
// import protien from '../assets/images/imgs/protien.png'
import { useNavigate } from "react-router-dom";

export default function GoldenShine() {
    const { t } = useTranslation();
    const navigate = useNavigate()

    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('brands');
    }, [])

    const pandySection = useRef()
    const pinnedPandyRef = useRef()

    window.onscroll = () => {

        if (pandySection.current.getBoundingClientRect().top < 20 && pandySection.current.getBoundingClientRect().top > -(pandySection.current.getBoundingClientRect().height - 280)) {
            pinnedPandyRef.current.classList.add('fixed')
        } else {
            pinnedPandyRef.current.classList.remove('fixed')
        }
    }
    return (
        <section className="relative flex gap-[20px] p-[20px] lg:p-[100px]" ref={pandySection}>
            <div className="w-[80px] min-w-[80px] lg:w-[150px] lg:min-w-[150px] relative">
                <div onClick={()=>navigate(-1)} ref={pinnedPandyRef} className="z-[999] top-[120px] bg-white border-[#D0A847] border-[2px] w-[80px] min-w-[80px] h-[80px] lg:w-[150px] lg:min-w-[150px] lg:h-[150px] flex items-center justify-center rounded-[10px] transition-all duration-700 cursor-pointer">
                    <img src={pandy} className="w-[50px] min-w-[50px] lg:w-[100px] lg:min-w-[100px]" alt="" />
                </div>
            </div>
            <div className="flex flex-col gap-[20px] px-[0px] lg:px-[100px]">
                <div className="flex flex-col gap-[50px]">
                    <h3 className="text-[#D0A847] underline capitalize underline-offset-[12px] decoration-[2px] text-lg lg:text-2xl 2xl:text-4xl nc">{t('golden_shine')}</h3>
                    <h2 className="capitalize text-md lg:text-xl nc">{t('golden_description1')}</h2>

                    <h2 className="capitalize text-md lg:text-xl nc">{t('golden_description2')}</h2>
                    <img src={candy} className="w-full lg:w-3/4 m-auto" alt="" />

                </div>
            </div>
        </section>
    )
}